import { MacroBar } from './MacroBar';
import { MacroRing } from './MacroRing';
import type { DailyMacros } from '../lib/api';

// MacroStrip — compact version of the Dashboard's nutrition card, sized
// for the Today screen where space is at a premium. Smaller ring (120px),
// thinner bars (4px height) so the whole strip fits in ~140px vertical.
//
// Same data inputs as the Dashboard nutrition card so the user sees a
// consistent macro snapshot whether they're glancing at the Dashboard or
// editing on Today. As the user logs meals, this updates from the next
// loadDailyLog response.
export function MacroStrip({ macros }: { macros: DailyMacros }) {
  return (
    <div className="surface-raised p-4">
      <p className="label-eyebrow mb-3">Today</p>
      <div className="flex items-center gap-4">
        <div className="shrink-0">
          <MacroRing
            consumed={macros.kcal.consumed}
            target={macros.kcal.target}
            unit="kcal"
            size={120}
            stroke={10}
          />
        </div>
        <div className="flex-1 flex flex-col justify-center gap-2 min-w-0">
          <MacroBar
            label="Protein"
            consumed={macros.protein.consumed}
            target={macros.protein.target}
            height={4}
          />
          <MacroBar
            label="Fat"
            consumed={macros.fat.consumed}
            target={macros.fat.target}
            height={4}
          />
          <MacroBar
            label="Carbs"
            consumed={macros.carbs.consumed}
            target={macros.carbs.target}
            height={4}
          />
        </div>
      </div>
    </div>
  );
}
